export const responseRedshiftEncryption = {
  data: {
    attributes: {
      password: 'awsRedshiftPassword'
    }
  }
};